import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Popover } from 'devextreme-react';
import { useId } from 'react-id-generator';
import withInspector from 'fulogics-ui-web/dist/layout/inspector/hoc/withInspector';
import { WarningIcon } from '../../../../assets/svg/WarningIcon';
import AllowedStacksHeaderSchema from './AllowedStacksHeaderSchema';

const AllowedStacksHeader = memo(({ className, title }: AllowedStacksHeaderDisplayOptions) => {
    const { t } = useTranslation('AllowedStacksHeader');
    const [targetId] = useId();
    const stackInfo: string[] = t('stackInfo', {
        returnObjects: true,
    });

    return (
        <>
            <div id={targetId} className={className}>
                {title || t('title')} <WarningIcon color="black" />
            </div>
            <Popover
                target={`#${targetId}`}
                showEvent="dxhoverstart"
                hideEvent="dxhoverend"
                dragEnabled={false}
                showTitle={false}
                width="315px"
                height="auto"
                position="top"
            >
                <div>
                    {stackInfo?.map((info) => (
                        <div key={info}>{info}</div>
                    ))}
                </div>
            </Popover>
        </>
    );
});

export type AllowedStacksHeaderProps = {} & AllowedStacksHeaderDisplayOptions;

export type AllowedStacksHeaderDisplayOptions = {
    id?: string;
    className?: string;
    title?: string;
};

export default withInspector<AllowedStacksHeaderProps>(
    AllowedStacksHeader,
    AllowedStacksHeaderSchema
);
